import React from 'react';
import { Progress } from 'antd';
import '../../../../../stylesheets/components/receiver/scorecard.scss';

interface PercentageProgressProps {
  percentage: number;
  strokeColor: string;
  showPercentage?: boolean;
  size?: 'small' | 'default';
}

const PercentageProgress: React.FC<PercentageProgressProps> = ({
  percentage,
  strokeColor,
  showPercentage = true,
  size = 'small',
}) => {
  return (
    <div className="percentage-progress__container">
      <div className="percentage-progress__bar">
        <Progress percent={percentage} showInfo={false} strokeColor={strokeColor} size={size} />
      </div>
      {showPercentage && (
        <div className="text-xs percentage-progress__label">{percentage.toFixed(1)}%</div>
      )}
    </div>
  );
};

export default PercentageProgress;
